module Meevo.Plugins.AppointmentBook {
    class CustomFieldsController {

        static $inject = [
            "$mdDialog", "$rootScope", "meevo.components.common.DataService", "$q"
        ];

        appArea: Model.AppAreaEnum;
        appointDetails: any[];
        canEdit: boolean;
        forceCancel: boolean;
        data: any[]=[];
        constructor(private $mdDialog, private $rootScope: angular.IRootScopeService, protected dataService: Meevo.Components.BaseClasses.IDataService, private $q) {
            let data = [];
            let promises = [];
            this.appointDetails.forEach((appointDetail) => {
                promises.push(this.getCustomControlsForAppointDetail(appointDetail, data));
            });

            $q.all(promises)
                .then(() => {
                    this.data = data;
                });
            this.canEdit = this.canEdit != undefined ? this.canEdit : true;
        }
        
        private getCustomControlsForAppointDetail(appointDetail, data) {
            let defer = this.$q.defer();
            this.dataService.add(`CustomData/ApptServiceAnswer/List`, {
                Criteria: {
                    apptServiceList: [
                        {
                            serviceId: appointDetail.service ? appointDetail.service.id : appointDetail.serviceId,
                            entityId: appointDetail.id
                        }
                    ],
                    appAreaEnum: this.appArea
                }
            })
                .then((appointmentServiceAnswers) => {
                    var customControls = _.pluck(appointmentServiceAnswers, "control");
                    // Merge in existing answers if they exist
                    if (appointDetail.customControlsAnswers) {
                        customControls.forEach((customControl) => {
                            customControl.answers = _.where(appointDetail.customControlsAnswers.answers,
                                { "control_TId": customControl.control_TId });
                        });
                    }

                    data.push({
                        customControls: customControls,
                        model: { answers: [] },
                        appointDetail: appointDetail
                    });
                    defer.resolve();
                });
            return defer.promise;
        }

        getHeaderText(appointDetail) {
            var serviceDisplayName = appointDetail.service
                ? appointDetail.service.displayName
            : appointDetail.serviceDisplayName;
            var text = serviceDisplayName + " " + (appointDetail.startDateTime ? moment(appointDetail.startDateTime).format("h:mm a") : "");
            return `${text}`;
        }
    

        save(isValid) {
            if (isValid) {
                this.$rootScope.$broadcast('prepareCustomControlsAnswers', { appAreaEnum: this.appArea, entity_Id: undefined });
                for (var i = 0; i < this.data.length; i++) {
                    this.data[i].appointDetail.customControlsAnswers = this.data[i].model;
                }
                
                this.$mdDialog.hide({ proceed: true, data: this.data });
            }
        }

        cancel(isValid) {
            let hasRequired = _.find(this.data, (data:any) => {
                return _.findWhere(data.customControls, {isRequired: true}) != undefined;
            });
            this.$mdDialog.hide({ proceed: this.forceCancel ? false : !hasRequired });
        }
    }

    angular.module("ApptBookApp").controller("meevo.plugins.appointmentbook.CustomFieldsController", CustomFieldsController);
}